<h1 class="d-flex justify-content-between align-items-center" mat-dialog-title>
  <span class="font-25 font-weight-bold">{{ data.title | translate }}</span>
  <i (click)="close()" [inlineSVG]="'assets/img/times1.svg'" class="svg-10 close-modal"></i>
</h1>
<!-- pause modal -->
<div *ngIf="data.type == 1">
  <mat-dialog-content class="overflow-auto">
    <div class="options d-flex align-items-center">
      <label>
        <input (change)="setServicePauseType($event)" [(ngModel)]="servicePauseType" name="servicePauseType"
               type="radio"
               value="1">
        <span class="pl-2">{{'pause-today' | translate}}</span>
      </label>
      <label>
        <input (change)="setServicePauseType($event)" [(ngModel)]="servicePauseType" name="servicePauseType"
               type="radio"
               value="2">
        <span class="pl-2">{{'pause-this-week' | translate}}</span>
      </label>
    </div>
    <div *ngIf="servicePauseType == '3'" class="calendar-wrapper">
      <mat-calendar #calendar
                    (monthSelected)="monthSelected($event)"
                    (selectedChange)="onDateChanged($event)"
                    [(selected)]="selectedDate"
                    [dateClass]="dateClass()" [minDate]="minDate"></mat-calendar>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex buttons-container-modal justify-content-center pb-4">
    <button [mat-dialog-close]="true" class="close-button">{{'cancel' | translate}}</button>
    <button (click)="pauseService()">{{'pause' | translate}}</button>
  </mat-dialog-actions>
</div>
<!-- add service -->
<div *ngIf="data.type == 2">
  <form #serviceForm="ngForm" [formGroup]="serviceFormGroup">
    <mat-dialog-content>
      <div class="row">
        <div class="col-lg-6">
          <div [class.is-invalid]="!isValid('serviceTypeId') && serviceForm.submitted" class="form-group">
            <ng-select
                (change)="onChangeType()"
                [(ngModel)]="data.service.serviceTypeId"
                [closeOnSelect]="true"
                [items]="data.serviceTypes"
                [multiple]="false"
                [searchable]="false"
                [selectableGroup]="true"
                bindLabel="value"
                bindValue="key"
                formControlName="serviceTypeId"
                [placeholder]="'serviceType' | translate">
              <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                <input [ngModel]="item$.serviceTypeId" name="{{ item.value }}" type="checkbox"/>
              </ng-template>
            </ng-select>
          </div>
          <div [class.is-invalid]="!isValid('specialityId') && serviceForm.submitted" class="form-group">
            <ng-select
                (change)="onChangeSpeciality(data.service.specialityId)"
                [(ngModel)]="data.service.specialityId"
                [closeOnSelect]="true"
                [items]="data.serviceSpecialties"
                [multiple]="false"
                [searchable]="false"
                [selectableGroup]="true"
                bindLabel="userSpecialtName"
                bindValue="specialtyId"
                formControlName="specialityId"
                [placeholder]="'speciality' | translate">
              <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                <input [ngModel]="item$.specialtyId" name="{{ item.specialityId }}" type="checkbox"/>
              </ng-template>
            </ng-select>
          </div>
          <div [class.is-invalid]="!isValid('serviceGroupId') && serviceForm.submitted" class="form-group">
            <ng-select
                (change)="onChangeGroup(data.service.serviceGroupId)"
                [(ngModel)]="data.service.serviceGroupId"
                [closeOnSelect]="true"
                [items]="data.serviceGroups"
                [multiple]="false"
                [searchable]="false"
                [selectableGroup]="true"
                bindLabel="value"
                bindValue="key"
                formControlName="serviceGroupId"
                [placeholder]="'service-group' | translate">
              <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                <input [ngModel]="item$.serviceGroupId" name="{{ item.value }}" type="checkbox"/>
              </ng-template>
            </ng-select>
          </div>
          <div [class.is-invalid]="!isValid('serviceGroupCategoryId') && serviceForm.submitted" class="form-group">
            <ng-select
                (change)="onChangeCategory()"
                [(ngModel)]="data.service.serviceGroupCategoryId"
                [closeOnSelect]="true"
                [items]="data.serviceCategories"
                [multiple]="false"
                [searchable]="false"
                [selectableGroup]="true"
                bindLabel="value"
                bindValue="key"
                formControlName="serviceGroupCategoryId"
                [placeholder]="'service-category' | translate">
              <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                <input [ngModel]="item$.serviceGroupCategoryId" name="{{ item.value }}" type="checkbox"/>
              </ng-template>
            </ng-select>
          </div>
          <div [class.is-invalid]="!isValid('specialityServiceConfigId') && serviceForm.submitted" class="form-group">
            <ng-select
                (change)="onChangeConfig($event)"
                [(ngModel)]="data.service.specialityServiceConfigId"
                [closeOnSelect]="true"
                [items]="data.serviceConfigs"
                [multiple]="false"
                [searchable]="false"
                [selectableGroup]="true"
                bindLabel="specialityServiceConfigNames"
                bindValue="specialityServiceConfigId"
                formControlName="specialityServiceConfigId"
                [placeholder]="'name-of-service' | translate">
              <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                <input [ngModel]="item$.specialityServiceConfigId" name="{{ item.specialityServiceConfigNames }}"
                       type="checkbox"/>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row infoes">
            <div class="col-lg-6">
              <span class="d-block">{{'popular-price' | translate}}:</span>
              <b>{{ serviceConfig.popularPrice }} GEL</b>
            </div>
            <div class="col-lg-6">
              <span class="d-block">{{'price-(from---to)' | translate}}:</span>
              <b
                  *ngIf="(serviceConfig.priceFrom || serviceConfig.priceFrom === 0) && serviceConfig.priceTo">{{ serviceConfig.priceFrom }}
                - {{ serviceConfig.priceTo }} GEL</b>
              <b *ngIf="!serviceConfig.priceFrom && !serviceConfig.priceTo"> GEL</b>
            </div>
          </div>
          <div [class.is-invalid]="!isValid('price') && serviceForm.submitted" class="form-group">
            <input [(ngModel)]="data.service.price" class="standard-input" decimalLimit
                   formControlName="price" [placeholder]="'my-price' | translate" type="text">
          </div>
          <div [class.is-invalid]="!isValid('commissionDoctor') && serviceForm.submitted" class="form-group">
            <input class="standard-input" decimalLimit
                   formControlName="commissionDoctor" [placeholder]="'fee' | translate" type="text">
          </div>
          <div *ngIf="!data.clinicAdminHttpParams"
               class="d-flex justify-content-between fee-info align-items-center mb-3">
            <span>{{'pageCommision' | translate}}</span>
            <b>{{ serviceConfig.commissionDoctor ? serviceConfig.commissionDoctor : '-' }}%
              ({{ getPriceDoctor(data.service.price, serviceConfig.commissionDoctor) }}
              GEL)</b>
          </div>
          <!--          <div class="d-flex justify-content-between fee-info align-items-center">-->
          <!--            <span>პაციენტის საკომისიო</span>-->
          <!--            <b>{{ serviceConfig.commissionPatient ? serviceConfig.commissionPatient : '-' }}%-->
          <!--              ({{ getPricePercent(data.service.price, serviceConfig.commissionPatient) }} GEL)</b>-->
          <!--          </div>-->
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="d-flex buttons-container-modal justify-content-center pb-4">
      <button [mat-dialog-close]="true" class="close-button">{{'cancellation' | translate}}</button>
      <button (click)="addService()" *ngIf="!data.service.doctorServiceId">{{'add' | translate}}</button>
      <button (click)="editService()" *ngIf="data.service.doctorServiceId">{{'save' | translate}}</button>
    </mat-dialog-actions>
  </form>
</div>
<!--  -->
<div *ngIf="data.type == 3">
  <mat-dialog-content>
    <div class="form-group">
      <input class="standard-input" [placeholder]="'type' | translate" type="text">
    </div>
    <div class="form-group">
      <input class="standard-input" [placeholder]="'type' | translate" type="text">
    </div>
    <div class="form-group">
      <input class="standard-input" [placeholder]="'type' | translate" type="text">
    </div>
    <div class="form-group">
      <textarea class="location-textarea standard-input" [placeholder]="'comment' | translate"></textarea>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex buttons-container-modal justify-content-center px-0 pb-4 border-top-0">
    <button [mat-dialog-close]="true" class="close-button">{{'cancel' | translate}}</button>
    <button>{{'add' | translate}}</button>
  </mat-dialog-actions>
</div>
<div *ngIf="data.type == 4">
  <mat-dialog-content class="overflow-auto">
    <div class="options d-flex align-items-center">
      <label>
        <input (change)="setCalendarPauseType($event)" [(ngModel)]="calendarPauseType" name="servicePauseType"
               type="radio"
               value="1">
        <span class="pl-2">{{'pause-today' | translate}}</span>
      </label>
      <label>
        <input (change)="setCalendarPauseType($event)" [(ngModel)]="calendarPauseType" name="servicePauseType"
               type="radio"
               value="2">
        <span class="pl-2">{{'pause-this-week' | translate}}</span>
      </label>
      <label>
        <input (change)="setCalendarPauseType($event)" [(ngModel)]="calendarPauseType" name="servicePauseType"
               type="radio"
               value="3">
        <span class="pl-2">{{'pause-on-specific-dates' | translate}}</span>
      </label>
    </div>
    <div *ngIf="calendarPauseType == '3'" class="calendar-wrapper">
      <!--      <mat-calendar #calendar-->
      <!--                    (monthSelected)="monthSelected($event)"-->
      <!--                    (selectedChange)="onDateChanged($event)"-->
      <!--                    [(selected)]="selectedDate"-->
      <!--                    [dateClass]="dateClass()"-->
      <!--                    [minDate]="minDate"></mat-calendar>-->
      <app-calendar #myCalendar  [doctorCalendar]="true" (dateSelected)="onDateChanged($event)" calendarType="dialog">
      </app-calendar>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex buttons-container-modal justify-content-center pb-4">
    <button [mat-dialog-close]="true" class="close-button">{{'cancel' | translate}}</button>
    <button (click)="pauseCalendar()">{{'pause' | translate}}</button>
  </mat-dialog-actions>
</div>
